import React, { useState } from 'react';
import TutorialModal from '../components/TutorialModal';

const TutorialPage = () => {
  const [isTutorialOpen, setIsTutorialOpen] = useState(true); // Auto-open tutorial

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center p-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-[#0176D3] to-[#0155A8] rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-white font-bold text-2xl">B</span>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Bissa Quick Start Tutorial</h1>
          <p className="text-xl text-gray-600 mb-8">
            Learn how to build meaningful relationships with Bissa.ai in just 5 minutes
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">What you'll learn:</h2>
          <div className="grid md:grid-cols-2 gap-6 text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-[#0176D3] font-bold text-sm">1</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Contact Management</h3>
                <p className="text-gray-600 text-sm">Add, organize, and search your customer database</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-green-600 font-bold text-sm">2</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Company Tracking</h3>
                <p className="text-gray-600 text-sm">Organize contacts by companies and accounts</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-purple-600 font-bold text-sm">3</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Sales Pipeline</h3>
                <p className="text-gray-600 text-sm">Track deals from lead to close with drag-and-drop</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-orange-600 font-bold text-sm">4</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Analytics & Reports</h3>
                <p className="text-gray-600 text-sm">Monitor performance and track key metrics</p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => setIsTutorialOpen(true)}
            className="px-8 py-4 bg-[#0176D3] text-white rounded-lg hover:bg-[#0155A8] transition-all font-medium text-lg inline-flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
          >
            Start 5-Minute Tutorial
          </button>
          
          <div>
            <a 
              href="/" 
              className="text-gray-600 hover:text-gray-900 underline"
            >
              ← Back to Home
            </a>
          </div>
        </div>
      </div>

      <TutorialModal 
        isOpen={isTutorialOpen}
        onClose={() => {
          setIsTutorialOpen(false);
          // Redirect to home after tutorial
          setTimeout(() => window.location.href = '/', 500);
        }}
      />
    </div>
  );
};

export default TutorialPage;